<ng-template #content let-modal>
  <div class="modal-header" style="height: 50px; width: 720">
    <h4
      class="modal-title mt-4"
      id="modal-basic-title"
      style="font-size: 16px; font-weight: bold"
    >
      Compose New Email
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true"> &times; </span>
    </button>
  </div>

	<div class="modal-body ">
		<div style="height: 20px">
			<p class="text-left px-3" id="esubText2" [ngStyle]="{ color: color }"> <i *ngIf="esubText2"
					class="fas fa-check-circle" style="margin-right: 3px"></i>{{ esubText2 }} </p>
			<p class="text-left px-3" id="esubText4" [ngStyle]="{ color: color }"> <i *ngIf="esubText4"
					class="fa fa-times-circle-o" style="margin-right: 3px"></i>{{ esubText4 }} </p>
			<p class="text-left px-3" id="esubText" [ngStyle]="{ color: color }"> <i *ngIf="esubText"
					class="fa fa-times-circle-o" style="margin-right: 3px"></i>{{ esubText }} </p>
			<p class="text-left px-3" id="saveFileText4" style="color: red"> {{ saveFileText4 }} </p>
		</div>
		<form #f="ngForm">
			<div class="row">
				<div class="col-md-12  px-3">
					<div class="col-md-12  px-3">
						<div class="form-group m-0"> <span style="font-size: 16px; font-weight: medium; color: black;">To
						  </span>
						  <input id="email_to" type="text" ngDefaultControl class="form-control bd-light bg-white" style="
							  font-weight: medium;
							  font-size: 14px;
							  background-color: #b4b4b4;
							  border-top: none;
							  border-right: none;
							  border-left: none;
							  border-radius: 0px;
							  border-bottom-color: #E3E3F0;
							  margin-top: 3px;
							" required autofocus readonly value="{{ emailAddress }}" />
						  <div class="float-right cc-bc" s>
							<button class="email-cc "> Cc</button>
							<button class="email-cc ms-1"> Bcc</button>
						  </div>
						</div>
					  </div>
				
				<div class="col-md-12 py-1 px-3">
					<div class="form-group m-0 mt-3"> <span style="font-size: 16px; font-weight: medium; color: black; ">Subject </span>
					  <input id="email_sub" type="text" name="email_sub" ngDefaultControl style="font-weight: medium; font-size: 14px;    border-top: none;
						border-right: none;
						border-left: none;
						border-radius: 0px;
						border-bottom-color: #E3E3F0;
						" class="form-control bd-light bg-white" required autofocus value="" />
					</div>
				  </div>
				<div class="col-md-12 py-1 px-3">
					<div class="form-group m-0" style="border: none; height: 275px">
						<textarea id="email_body" name="email_body" ngDefaultControl
							class="form-control w-100 border-none" onfocus="this.placeholder=''"
							onblur="this.placeholder='Write your message...'" placeholder="Write your message..."
							rows="6" style="padding: 6px; font-size: 16px; font-weight: 400;  border-top: none;
                    border-right: none;  outline: none;
					resize: none;
                    border-left: none;
                    border-radius: 0px;
                    border-bottom:none"></textarea>
					</div>
				</div>
			</div>
			</div>
		</form>
	</div>
	<div class="modal-footer  px-1 pt-0  position-relative" style="justify-content: space-between">
        <div class="tooltip_attach" *ngIf="isTooltipVisible" style="width: 310px;     height: 160px;; margin-top: -42px;">
          <div class="form-check"
            style="background-color: #dcdcdc; font-size: 0px; padding-top: 9px; height: 60px; border-radius: 6px;">
            <input type="radio" style="margin-left: -17px; margin-top: 15px; font-size: 11px;" class="form-check-input"
              id="html" name="fav_language" value="HTML" [(ngModel)]="model.attachpdf"
              (click)="captureScreen(model.attachpdf)" />
            <label class="form-check-label" for="html">
              <a style="cursor: pointer" class="pdf_icon"> <img class="img-fluid ms-2"
                  src="/../../assets/images/downlaod/pdf.svg" alt="pdf-icon" /> <span
                  style="font-weight: bold; font-size: 14px; margin-left: 10px; margin-top: 10px;">
                  Attach current document as PDF
                </span> </a>
            </label>
          </div>
          <hr class="my-2" />
          <div class="form-check"
            style="padding-top: 9px; background-color: #dcdcdc; font-size: 0px; height: 60px; border-radius: 6px;">
            <input style="margin-top: 20px; margin-left: -17px; font-size: 11px;" class="form-check-input" type="radio"
              id="css" name="fav_language" value="css" [(ngModel)]="model.attachdocx"
              (click)="captureScreenfordoc(model.attachdocx)" />
            <label for="css" class="form-check-label">
              <a style="cursor: pointer" class="doc_icon"> <img class="img-fluid ms-2"
                  src="/../../assets/images/downlaod/doc.svg" /> <span
                  style="font-weight: bold; font-size: 14px; margin-left: 10px; margin-top: 7px;">
                  Attach current document as DOC
                </span> </a>
            </label>
          </div>
        </div>
        <div class="col-12" style="display: flex;align-items: center; justify-content: space-between; ">
          <div class="tooltip-wrapper  justify-content-center mt-2 " style="    border: 1px solid #E3E3F0;
          border-radius: 5px;
          width: 33px;
          height: 33px;
          cursor: pointer;
        "
        (click)="toggleTooltip()"
      >
        <img
          id="attach_file"
          class="img-fluid ms-2 mt-1"
          src="assets/images/tool/attach.svg"
          alt="attach-file"
          width="16.43px"
          height="16.5px"
        />
        <span class="custom-tooltip">Attach file</span>
      </div>
      <div class="float-right">
        <button
          type="button"
          class="discord me-2"
          data-dismiss="modal"
          aria-label="Close"
          (click)="clearemail()"
        >
          Discard
        </button>
        <button type="button" class="send" (click)="eSubmission(f)">
          Send
        </button>
      </div>
    </div>
  </div>
</ng-template>
<button
  class="btn btn-lg btn-outline-primary d-none"
  (click)="openModels(content)"
>
  Compose Email
</button>
